export default __webpack_public_path__ + "static/media/TVSmotocarroFamilia.22bf961a.webp";